import {stringInject} from "./stringInject";
import {executor, findParams} from "./js-to-string";

const getParamsFromString = (string = "", globalValues, screenName, actions, escapeHtmlParams, generatedScript) => {
    let foundParams = findParams(string, globalValues, screenName, actions, escapeHtmlParams, generatedScript);
    return globalValues ? stringInject(string, foundParams.objectValues) : undefined;
};
export default getParamsFromString;

export function executeJsString(string = "", globalValues, screenName, actions) {
    const script = string ? string : 'return undefined'
    return executor(`(function(){${script}}())`, globalValues, screenName, actions);
}